import { render, staticRenderFns } from "./zeroZone.vue?vue&type=template&id=17a4630a&scoped=true"
import script from "./zeroZone.vue?vue&type=script&lang=js"
export * from "./zeroZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a4630a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a4630a')) {
      api.createRecord('17a4630a', component.options)
    } else {
      api.reload('17a4630a', component.options)
    }
    module.hot.accept("./zeroZone.vue?vue&type=template&id=17a4630a&scoped=true", function () {
      api.rerender('17a4630a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/components/zeroZone.vue"
export default component.exports